import { EDUCATION_OFFERS, LEARNING_TYPES } from '@sravni/ugc/lib/specialOffers/lists';
import type { LearningTypes } from '@sravni/ugc/lib/specialOffers/types';

import { getProgrammingConditions } from '../../helpers/conditions/education/programming';
import type { OfferTab } from '../../helpers/getProductData';

const commonData = {
  key: { type: EDUCATION_OFFERS.learning },
  label: 'курс',
  linkToOneProduct: '',
  getConditions: getProgrammingConditions,
  advertisingCategory: 'Курсы',
};

export const learningTypeInfo: Record<LearningTypes, OfferTab> = {
  [LEARNING_TYPES.typeProgramming]: {
    ...commonData,
    generalLink: '/kursy/programmirovanie/',
  },
  [LEARNING_TYPES.typeAnalytics]: {
    ...commonData,
    generalLink: '/kursy/analitika/',
  },
  [LEARNING_TYPES.typeMarketing]: {
    ...commonData,
    generalLink: '/kursy/marketing/',
  },
  [LEARNING_TYPES.typeDesign]: {
    ...commonData,
    generalLink: '/kursy/dizajn-graficheskij/',
  },
  [LEARNING_TYPES.typeManagement]: {
    ...commonData,
    generalLink: '/kursy/menedzhment/',
  },
  [LEARNING_TYPES.typeAdmin]: {
    ...commonData,
    generalLink: '/kursy/programmirovanie-sistemnoe-administrirovanie/',
  },
  [LEARNING_TYPES.typeFinance]: {
    ...commonData,
    generalLink: '/kursy/finansy/',
  },
  [LEARNING_TYPES.typeLanguage]: {
    ...commonData,
    generalLink: '/kursy/inostrannye-yazyki/',
  },
  [LEARNING_TYPES.typeCreativity]: {
    ...commonData,
    generalLink: '/kursy/creativity-make/',
  },
  [LEARNING_TYPES.typeSoftSkills]: {
    ...commonData,
    generalLink: '/kursy/samorazvitie/',
  },
  [LEARNING_TYPES.typeApplication]: {
    ...commonData,
    generalLink: '/kursy/rukodelie/',
  },
  [LEARNING_TYPES.typeBeauty]: {
    ...commonData,
    generalLink: '/kursy/beauty/',
  },
  [LEARNING_TYPES.typePO]: {
    ...commonData,
    generalLink: '/kursy/menedzhment-microsoft-office/',
  },
  [LEARNING_TYPES.typeSport]: {
    ...commonData,
    generalLink: '/kursy/sport/',
  },
  [LEARNING_TYPES.typeDPO]: {
    ...commonData,
    generalLink: '/kursy/povyshenie-kvalifikacii/',
  },
};
